<template>
    <div class="card-news skeleton">
        <div class="header">
            <div class="avatar skeleton-box circle"></div>
            <div class="name-news skeleton-box large"></div>
        </div>
        <div class="info">
            <div class="description skeleton-box large"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardNewsSkeleton',
};
</script>

<style lang="scss" scoped>
.card-news {
    border-top: 1px solid rgba(16, 24, 40, 0.1);
    padding-top: 20px;
    padding-bottom: 32px;

    .header {
        display: flex;
        align-items: center;
        margin-left: 8px;

        .avatar {
            margin-left: 8px;
            width: 30px;
            height: 30px;
        }

        .name-news {
            margin-left: 8px;
            height: 38px;
        }
    }

    .info {
        margin-left: 16px;

        .description {
            margin-top: 20px;
            height: 20px;
        }
    }
}
</style>
